var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8637 1.89186C19.1338 2.21517 18.3487 2.4309 17.5206 2.53297C18.3625 2.0331 19.0102 1.23586 19.3142 0.294069C18.5263 0.755862 17.6535 1.09517 16.725 1.27393C15.9835 0.487724 14.9258 0 13.7539 0C11.5029 0 9.67835 1.80855 9.67835 4.03862C9.67835 4.35421 9.71531 4.66152 9.78483 4.96C6.39835 4.79007 3.39476 3.18014 1.38538 0.737104C1.03228 1.33407 0.833655 2.0331 0.833655 2.77076C0.833655 4.17269 1.55145 5.4069 2.64607 6.13407C1.97793 6.11366 1.34897 5.92772 0.798345 5.62979C0.798345 5.64193 0.798345 5.66014 0.798345 5.67724C0.798345 7.63641 2.20359 9.26786 4.06621 9.63917C3.72579 9.73241 3.36607 9.78428 2.99531 9.78428C2.73214 9.78428 2.47559 9.75448 2.22731 9.70979C2.74593 11.3109 4.25048 12.4811 6.0331 12.5159C4.63834 13.5972 2.88166 14.245 0.971586 14.245C0.641655 14.245 0.318897 14.2262 0 14.1876C1.80469 15.3302 3.94759 16 6.24772 16C13.7429 16 17.8433 9.84497 17.8433 4.50538C17.8433 4.33048 17.8378 4.15614 17.8295 3.984C18.6295 3.41903 19.3192 2.70621 19.8637 1.89186Z",
    fill: "#03A9F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.19a7ec0acfd64ee6696d68291933e471.svg";
export { ForwardRef as ReactComponent };